import Route from '@ember/routing/route';
import type PublicTransition from '@ember/routing/transition';
import { service } from '@ember/service';

import type { Service } from 'webapp-types';

import type DesignerBoardBlockController from 'webapp/controllers/designer/board/block';

import type BlockRecord from 'webapp/models/block';
import type BoardRecord from 'webapp/models/board';

export default class DesignerBoardBlockRoute extends Route {
	@service('model-manager/boards') declare mmBoardsService: Service.ModelManager.Boards;
	@service('store') declare storeService: Service.Store;
	@service('navigation') declare navigationService: Service.Navigation;

	override model(params: { block_id: string }): BlockRecord | string {
		const block = this.storeService.peekRecord('block', params.block_id) as BlockRecord | null;
		return block || params.block_id;
	}

	override afterModel(model: BlockRecord | string, transition: PublicTransition): void {
		let boardId;
		try {
			boardId = (
				transition.resolvedModels['designer.board'] as BoardRecord | null | undefined
			)?.id;
		} catch (_e) {
			// skip
		}
		const blockNotFound = typeof model === 'string'; // is the param
		if (blockNotFound && boardId && this.mmBoardsService.isBoardDataRequested(boardId)) {
			// if data for this board is already loaded, but still no block, redirect to board
			this.navigationService.replaceRoute(
				'designer.board',
				this.storeService.peekRecord('board', boardId),
			);
		}
	}

	override setupController(
		controller: DesignerBoardBlockController,
		model: BlockRecord | string,
		transition: PublicTransition,
	): void {
		let blockId, actualModel: BlockRecord | null;

		if (typeof model === 'string') {
			blockId = model;
			actualModel = null;
		} else {
			blockId = model.id!;
			actualModel = model;
		}

		super.setupController(controller, actualModel || {}, transition);

		controller.blockId = blockId;

		if (actualModel) {
			controller.selectBlock(blockId);
		}
	}
}
